import axios from 'axios';
import moment from 'moment';
import store from '@/store';

let requestCount = 0;

let loadingResolves = [];
const resolvePromises = () => {
  if (requestCount === 0) {
    setTimeout(() => {
      loadingResolves.forEach(resolve => resolve());
      loadingResolves = [];
    });
  }
};

export const Loading = {
  increment(conf) {
    requestCount += 1;
    if (conf.handleLoading === undefined || conf.handleLoading === true) {
      store.commit('app/setLoading', true);
    }
  },
  decrement() {
    requestCount -= 1;
    if (requestCount === 0) {
      store.commit('app/setLoading', false);
      resolvePromises();
    }
  },
  waitForApiCalls() {
    const promise = new Promise((resolve) => {
      if (requestCount === 0) {
        resolve();
      } else {
        loadingResolves.push(resolve);
      }
    });
    resolvePromises();
    return promise;
  },
};

//PROD
//baseURL: '//eb.kezber.ca/api',
const HTTP = axios.create({
  //baseURL: '//localhost:60993//api',
  //baseURL: 'http://ebtest.kez/api',
  baseURL: '//eb.kezber.ca/api',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});
/*
if (process.env.NODE_ENV !== 'production') {
  HTTP.setBaseURL('//localhost:1921/api');
}

export const HTTP = axios.create({
  baseURL: '//localhost:1921/api',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});
*/
HTTP.interceptors.request.use(
  conf =>
    Loading.waitForApiCalls().then(() => {
      const c = conf;
      Loading.increment(c);
      return c;
    }),
  (error) => {
    Loading.decrement();

    if (error.config.handleErrors === undefined || error.config.handleErrors === true) {
      store.commit('alert/add');
    }

    return Promise.reject(error);
  },
);

const parseDate = (str) => {
  const dateRegex = /\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d\.?\d*\+\d\d:\d\d/.exec(str);
  if (dateRegex && dateRegex.length > 0) {
    return moment(str).toDate();
  }
  return str;
};

const parseReturnObject = (obj) => {
  if (typeof obj !== 'object') {
    return;
  }

  Object.keys(obj).forEach((key) => {
    if (!obj[key]) {
      return;
    }

    if (typeof obj[key] === 'string') {
      // eslint-disable-next-line
      obj[key] = parseDate(obj[key]);
    } else if (Array.isArray(obj[key])) {
      obj[key].forEach(el => parseReturnObject(el));
    } else if (typeof obj[key] === 'object') {
      parseReturnObject(obj[key]);
    }
  });
};

HTTP.interceptors.response.use((response) => {
  Loading.decrement();

  if (response.errors !== undefined) {
    if (response.errors.length > 0) {
      store.commit('alert/add', { code: 500 });
    }
  }

  parseReturnObject(response);

  return response;
});

export default HTTP;
